import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    showJobFocusOther: Boolean,
    showProfessionalGroupOther: Boolean,
    showDiscountFields: Boolean
  }

  static targets = ["jobFocusOtherField", "professionalGroupOtherField", "discountFields"]

  connect() {
    console.log("here i am")
    this.toggle(this.jobFocusOtherFieldTarget, this.showJobFocusOtherValue)
    this.toggle(this.professionalGroupOtherFieldTarget, this.showProfessionalGroupOtherValue)
    this.toggle(this.discountFieldsTarget, this.showDiscountFieldsValue)
  }

  toggle(element, show) {
    if (!element) return
    if (show) {
      element.classList.remove("opacity-0", "scale-95", "max-h-0", "overflow-hidden")
      element.classList.add("opacity-100", "scale-100", "max-h-[1000px]")
    } else {
      element.classList.add("opacity-0", "scale-95", "max-h-0", "overflow-hidden")
      element.classList.remove("opacity-100", "scale-100", "max-h-[1000px]")
    }
    element.setAttribute("aria-hidden", (!show).toString())

    element.querySelectorAll("input, select, textarea, button").forEach(el => {
      el.disabled = !show
    })
  }

  toggleJobFocus(event) {
    const show = event.target.checked && event.target.dataset.showOther === "true"
    this.toggle(this.jobFocusOtherFieldTarget, show)
  }

  toggleProfessionalGroup(event) {
    const position =  event.target.dataset.position
    const show = position === "9999"
    this.toggle(this.professionalGroupOtherFieldTarget, show)

    const isDiscounted = event.target.dataset.discounted == "true"
    this.toggle(this.discountFieldsTarget, isDiscounted)
  }

  toggleDiscountFields(event) {
    const isDiscounted = event.target.dataset.discounted == "true"
    console.log(event.target.dataset)
    const show = isDiscounted // customize condition as needed
    this.toggle(this.discountFieldsTarget, show)
  }
}
